export default "__VITE_PUBLIC_ASSET__e81e4503__"